var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"zan"},[_c('img',{ref:"image",staticClass:"zan-image",attrs:{"src":require("../assets/zan.png")},on:{"click":_vm.click}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }